import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../../../libs'
import { $params } from '../../../../../../features/router'

export const tokensListMounted = createEvent<any>()

export const ordersByPropertyListMounted = createEvent<any>()

export const getTokensList = fx<any, any>({
  method: 'GET',
  url: `/nova/token_property/by_client`,
})

export const getOrdersByPropertyList = fx<any, any>({
  method: 'GET',
  url: `/nova/order/by_client/{id}/by_property/{id}`,
})

export const $tokensList = restore<any>(
  getTokensList.doneData.map((a) =>
    a.body.items.map((item: any) => ({ ...item, key: item.propertyId })),
  ),
  [],
)

export const $totalCountOfTokensList = restore(
  getTokensList.doneData.map((a) => a.body.total),
  0,
)

export const $ordersByPropertyList = restore<any>(
  getOrdersByPropertyList.doneData.map((a) => a.body.items),
  [],
)

sample({
  // @ts-ignore
  clock: tokensListMounted,
  source: $params,
  fn: (params, { limit, page, orderBy, orderDirection }) => {
    let clientID
    if (params) {
      clientID = params.clientID
    }

    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    return {
      query,
      url: `/nova/token_property/by_client/${clientID}`,
    }
  },
  target: getTokensList,
})

sample({
  clock: ordersByPropertyListMounted,
  source: $params,
  fn: (params, { propertyId }) => {
    let clientId
    if (params) {
      clientId = params.clientID
    }

    return {
      url: `/nova/order/by_client/${clientId}/by_property/${propertyId}`,
    }
  },
  target: getOrdersByPropertyList,
})
